<template>
  <div class="step_container">
    <div v-for="(item,idx) in list" :key="idx" class="step" :class="{active_step:item.idx==current}">{{item.idx}}、{{item.label}}</div>
  </div>
</template>

<script>
export default {
  name: "step",
  props:{
    current:{
      type:Number,
      required:true
    }
  },
  data(){
    return {
      list:[
        {
          idx:1,
          label:"导入文件并设置检查项"
        },
        {
          idx:2,
          label: "智能对比检查过程"
        },
        {
          idx:3,
          label: "智能检查结果"
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.step_container{
  height: 40px;
  display: flex;
}
.step{
  height: 40px;
  color: #646A73;
  background: #F8F9FA;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  padding: 0px 40px;
  margin-right: 30px;
  box-sizing: border-box;
}
.active_step{
  background: #1A66FF;
  color: #fff;
}

</style>
